module.exports = __webpack_public_path__ + "img/project15_6.jpeg.40a45ae7.webp";